import { HisSearchResultRow, HisBaseGlobalsService, HisUiService } from 'hisng';

export class DetailViewListUtils {

    public static getRowByLabelKey(row: HisSearchResultRow, label: string): any {
        let index = row.metadata.findIndex(md => md.label === label);
        return index !== -1 ? row.values[index] : '';
    }

    public static lowerCasedFirstLetter(text: string) {
        return text[0].toLowerCase() + text.substring(1);
    }

    public static upperCasedFirstLetterOfAllWords(text: string, seperator: string) {
        let words = text.split(seperator);
        for (let i = 0; i < words.length; i++) {
            words[i] = words[i][0].toUpperCase() + words[i].substring(1);
        }
        return words.join(seperator);
    }

    public static camelCase(underlinedConnected: string): string {
        let result = this.upperCasedFirstLetterOfAllWords(underlinedConnected, '_').replace('_', '');
        result = this.lowerCasedFirstLetter(result);
        return result;
    }

    public static capitalizeFirstLetter(text: string) {
        return text?.length > 0 ? text[0].toUpperCase() + text.substring(1) : '';
    }

    public static assembleToolTip(entryType: any, entryTitle: any,
        hisBaseGlobalsService: HisBaseGlobalsService, hisUiService: HisUiService): string {

        let toolTipText = entryType;
        if (hisBaseGlobalsService.getLanguage() !== 'de') {
            toolTipText = this.lowerCasedFirstLetterOfAllWords(entryType, ' ');
        }
        return (hisUiService.translate('common.showOf', toolTipText + ' ' + entryTitle));
    }

    public static lowerCasedFirstLetterOfAllWords(text: string, seperator: string) {
        let words = text.split(seperator);
        for (let i = 0; i < words.length; i++) {
            words[i] = this.lowerCasedFirstLetter(words[i]);
        }
        return words.join(seperator);
    }
}
